import { PuckPage } from "src/api/client-api/cms/useCreatePuckPage";

/**
 * Resolve allowed roles from API field or (legacy) embedded JSON in content.
 */
export const getPageRoles = (page: PuckPage): string[] => {
    if (Array.isArray(page.allowedRoles)) return page.allowedRoles as string[];
    try {
        if (page.content) {
            const contentObj = JSON.parse(page.content);
            return contentObj?.roles?.allowedRoles || [];
        }
    } catch {
        // ignore
    }
    return [];
};
